/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl, intlShape } from 'react-intl';
import {
  Grid,
  Row,
  Col,
} from 'react-bootstrap';
import Nvl from 'loracoms/Nvl';
import deviceActions from 'loraactions/device';
import Toolbar from 'loracoms/Toolbar';
import IntlMsg from 'lorautils/intl/IntlMsg';
import callAPI from '@/api/callAPI';
import Status from './Status';
import Channels from './Channels';
import LinksPie from './LinksPie';
import Logs from './Logs';
import styles from '../GatewayStatus/styles.scss';

const propTypes = {
  intl: intlShape.isRequired,
  id: React.PropTypes.string.isRequired,
  getDevice: PropTypes.func.isRequired,
  replaceState: React.PropTypes.func.isRequired,
  deviceDetail: PropTypes.object.isRequired,
};

class NodeStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: '',
      nodeStatus: {},
      deviceDetail: props.deviceDetail,
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.tdm.detailview');
  }

  componentDidMount() {
    const { id, getDevice } = this.props;
    getDevice(id);
    this.loadStatus();
  }

  componentWillReceiveProps({ deviceDetail }) {
    if (!_.isEqual(deviceDetail, this.props.deviceDetail)) {
      this.setState({ deviceDetail });
    }
  }

  loadStatus() {
    this.setState({ status: 'pending' });
    callAPI({
      endpoint: `/tdmng/nodes/${this.props.id}/status`,
    }).then((res) => {
      this.setState({ status: 'success', nodeStatus: res });
    }).catch(() => {});
  }

  renderToolbar() {
    const { replaceState } = this.props;
    const { deviceDetail: { status, data = {} } } = this.state;

    // '/network/tdm'
    const breadcrumb = [{
      onClick: () => replaceState('/network/tdm'),
      content: this.intlMsg.msg('toolbar.firstnav'),
    }, {
      content: <Nvl val={data.name} status={status} />,
      active: true,
    }];
    return (
      <Toolbar breadcrumb={breadcrumb} />
    );
  }

  render() {
    const {
      status,
      nodeStatus,
    } = this.state;
    return (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.renderToolbar()}
          </Col>
        </Row>
        <Row className={styles.row}>
          <Col md={8}>
            <Channels nodeStatus={nodeStatus} status={status} />
            <Logs nodeStatus={nodeStatus} />
            <LinksPie nodeStatus={nodeStatus} status={status} />
          </Col>
          <Col md={4}>
            <Status nodeStatus={nodeStatus} status={status} />
          </Col>
        </Row>
      </Grid>
    );
  }
}

NodeStatus.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  id: ownProps.params.id,
  deviceDetail: state.device.getDevice,
});

const mapDispatchToProps = {
  replaceState: routerActions.replace,
  getDevice: deviceActions.getDevice,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(NodeStatus));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/TDMView/NodeStatus/index.jsx